module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Carmen Kingsley","short_name":"Carmen Kingsley","start_url":"/","background_color":"#ffffff","theme_color":"#111111","display":"minimal-ui","icon":"src/images/headshot.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"07d76eb64bd852cf65d86bb76207fbbd"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
